const EMAIL_MESSAGE_STATUS = Object.freeze({
    DRAFTING: 0,
    SENDING: 1,
    SENT: 2,
    WARNING: 3
});

export {EMAIL_MESSAGE_STATUS}




// WEBPACK FOOTER //
// ./src/enums/emails.js